import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-12px font-normal font-poppins mb-4",
  style: {"color":"#A7A8AA"}
}
const _hoisted_2 = { class: "flex flex-col gap-y-2" }
const _hoisted_3 = { class: "w-6 mr-3 rounded" }
const _hoisted_4 = { class: "flex flex-col cursor-pointer w-full" }
const _hoisted_5 = { class: "text-12px font-normal font-montserrat text-gray-lp-300" }
const _hoisted_6 = { class: "text-12px font-normal font-montserrat text-gray-lp-300" }
const _hoisted_7 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M5.72386 1.72378C5.97391 1.47373 6.31304 1.33325 6.66667 1.33325H9.33333C9.68696 1.33325 10.0261 1.47373 10.2761 1.72378C10.5262 1.97382 10.6667 2.31296 10.6667 2.66659V3.99992H13.3333C13.7015 3.99992 14 4.2984 14 4.66659C14 5.03478 13.7015 5.33325 13.3333 5.33325H13.2874L12.7537 12.8086C12.7536 12.8086 12.7537 12.8085 12.7537 12.8086C12.7177 13.3131 12.4919 13.7854 12.1218 14.1302C11.7516 14.4749 11.2645 14.6666 10.7587 14.6666H5.24135C4.73549 14.6666 4.24842 14.4749 3.87823 14.1302C3.50809 13.7854 3.28231 13.3133 3.24636 12.8087C3.24636 12.8087 3.24636 12.8088 3.24636 12.8087L2.71257 5.33325H2.66667C2.29848 5.33325 2 5.03478 2 4.66659C2 4.2984 2.29848 3.99992 2.66667 3.99992H5.33333V2.66659C5.33333 2.31296 5.47381 1.97382 5.72386 1.72378ZM6.66667 3.99992H9.33333V2.66659H6.66667V3.99992ZM4.0493 5.33325L4.57631 12.7138C4.58828 12.882 4.66355 13.0395 4.78695 13.1544C4.91034 13.2694 5.0727 13.3333 5.24133 13.3333H10.7587C10.9273 13.3333 11.0897 13.2694 11.2131 13.1544C11.3364 13.0395 11.4117 12.8821 11.4237 12.7139L11.9507 5.33325H4.0493ZM6.66667 6.66659C7.03486 6.66659 7.33333 6.96506 7.33333 7.33325V11.3333C7.33333 11.7014 7.03486 11.9999 6.66667 11.9999C6.29848 11.9999 6 11.7014 6 11.3333V7.33325C6 6.96506 6.29848 6.66659 6.66667 6.66659ZM9.33333 6.66659C9.70152 6.66659 10 6.96506 10 7.33325V11.3333C10 11.7014 9.70152 11.9999 9.33333 11.9999C8.96514 11.9999 8.66667 11.7014 8.66667 11.3333V7.33325C8.66667 6.96506 8.96514 6.66659 9.33333 6.66659Z",
    fill: "#B82025"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadFile = _resolveComponent("UploadFile")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", null, [
      _createVNode(_component_UploadFile, {
        modelValue: _ctx.attachmentImage,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.attachmentImage = $event)),
        caption: ".png, jpeg up to 5 MB",
        showInfoDraggable: false,
        showFileDetail: false,
        allowed: "image/jpeg, image/jpg, image/png",
        class: "w-full my-2 mb-4",
        maxSize: 5,
        disabled: _ctx.attachments.length === _ctx.maxPhoto,
        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.attachments.length === _ctx.maxPhoto ? null : _ctx.onUpload())),
        type: "image",
        isShowRemarkError: ""
      }, null, 8, ["modelValue", "disabled"])
    ]),
    (_ctx.attachments.length === _ctx.maxPhoto)
      ? (_openBlock(), _createBlock("p", _hoisted_1, _toDisplayString(_ctx.$t("requestHal.maxUploadPhoto", { max: _ctx.maxPhoto })), 1))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.attachments, (detailData, index) => {
        return (_openBlock(), _createBlock("div", {
          class: "p-2 flex flex-row items-center rounded border border-solid border-gray-lp-400",
          key: index
        }, [
          _createVNode("div", _hoisted_3, [
            _createVNode("img", {
              src: detailData.image,
              class: "w-full h-full object-contain rounded",
              alt: "img-upload-delivery"
            }, null, 8, ["src"])
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode("p", _hoisted_5, _toDisplayString(detailData.name), 1),
            _createVNode("p", _hoisted_6, [
              _createTextVNode(_toDisplayString(detailData.size) + " - ", 1),
              _createVNode("span", {
                class: 
                `font-medium ${
                  detailData.status === 'success'
                    ? 'text-green-lp-100'
                    : 'text-red-lp-100'
                }`
              
              }, _toDisplayString(detailData.status === "success"
                  ? _ctx.$t("requestHal.uploadSuccess")
                  : _ctx.$t("requestHal.uploadFailed")), 3)
            ])
          ]),
          _createVNode("div", {
            class: "cursor-pointer",
            onClick: ($event: any) => (_ctx.onRemove(index))
          }, [
            _hoisted_7
          ], 8, ["onClick"])
        ]))
      }), 128))
    ])
  ]))
}